<div class="flex gap-2 py-1" *ngFor="let i of repeatList">
  <div class="bg-slate-200 w-3/12 h-6 rounded-md animate-pulse"></div>
  <div class="bg-slate-200 w-9/12 h-6 rounded-md animate-pulse"></div>
</div>
